import { NavigateBackLink } from '@exam-center/components';
import { ExamDistributionByMonthProvider } from '@exam-center/exam-distribution';
import { useExamDistributionSearchParams } from '@exam-center/exam-distribution-list';
import { getExamDistributionTitle, getMonthOrder } from '@exam-center/exam-distribution-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { useParams } from '@exam-center/router';
import { PageHeader } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ExamDistributionByMonthPageLayout() {
  const { year, month } = useParams('/admin/exam-distribution/year/:year/month/:month');

  const yearValue = parseInt(year);
  const monthValue = getMonthOrder(month) + 1;

  const [{ examDate, examCenters, provinces }] = useExamDistributionSearchParams();

  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.EXAM_ASSIGNING.VIEW}
    >
      <ExamDistributionByMonthProvider
        year={yearValue}
        month={monthValue}
        examDate={examDate}
        examCenterCodes={examCenters}
        provinceIds={provinces}
      >
        <PageHeader
          title={getExamDistributionTitle(parseInt(year), month)}
          linkAdornment={
            <NavigateBackLink
              to='/admin/exam-distribution/year/:year'
              params={{ year }}
              label='Back'
            />
          }
        />
        <Outlet />
      </ExamDistributionByMonthProvider>
    </PermissionGuard>
  );
}
